import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { getClientPortalToken, getClientPortalCompany } from "../../api/clientPortal";

export default function RequireClientPortal({ children }) {
  const [params] = useSearchParams();
  const company = params.get("company") || getClientPortalCompany();
  const token = getClientPortalToken();

  if (!token || !company) {
    const q = company ? `?company=${encodeURIComponent(company)}` : "";
    return <Navigate to={`/portal-cliente${q}`} replace />;
  }

  return children;
}
